module.exports = __webpack_public_path__ + "img/46ne.e2d799db.svg";